import React, { useCallback, useState, useRef, useEffect, useContext } from "react";
import styles from "./ShopCTA.module.css";
import ProgressBar from "../components/ProgressBar";
import NavPanel from "../components/NavPanel";
import { useNavigate } from "react-router-dom";
import { AudioContext } from "../AudioContext";
import TapArea from "../components/TapArea";
import Popup from "../components/Popup";

const MShopCTA = () => {
  const navigate = useNavigate();
  const { muted, setMuted } = useContext(AudioContext);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const [showLogo, setShowLogo] = useState(false);
  const videoRef = useRef(null);
  const [popupVisible, setPopupVisible] = useState(false);

  const onPreviousPageClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleMuteToggle = () => {
    setMuted((prev) => {
      const newMuted = !prev;
      if (videoRef.current) {
        videoRef.current.muted = newMuted;
      }
      return newMuted;
    });
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = muted;
    }
  }, [muted]);

  const handleVideoLoad = () => {
    setIsVideoLoading(false);
  };

  const handleVideoError = () => {
    setIsVideoLoading(false);
  };

  const onClickLink = () => {
    setPopupVisible(true)
    const link = 'https://www.newbalance.com/'
    umami?.track('Client Link - Shop CTA', { link: link } );
  }

  const onClickMeet = useCallback(() => {
    umami?.track('Interaction - Meet Athlete on Shop CTA');
    navigate('/who-best');
  }, [navigate]);

  // Track video time to show/hide logo
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const currentTime = video.currentTime;

      if (currentTime > 8.12 && showLogo) {
        setShowLogo(false);
      } else if (currentTime >= 1.2 && currentTime <= 8.12 && !showLogo) {
        setShowLogo(true);
      } else if (currentTime < 1.2 && showLogo) {
        setShowLogo(false);
      }
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    return () => {
      video.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [showLogo]);
  
  return (
    <div className={styles.shopCta}>
      <ProgressBar current='6' />
      <NavPanel onClick={onPreviousPageClick} />
      <TapArea style={styles.tapPrevious} onClick={onPreviousPageClick} />

      {isVideoLoading && (
        <div className={styles.loadingSpinner}>
          <div className={styles.spinner}></div>
        </div>
      )}
      
      <video
        ref={videoRef}
        className={styles.bgVideo}
        src="shopcta_assets/endingclip.mp4"
        autoPlay
        loop
        playsInline
        muted={muted}
        onPlaying={handleVideoLoad}
        onError={handleVideoError}
      />
      <div className={styles.gradient}></div>

      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>
          Check out our full<br />Football Collection
        </h1>
        <div className={styles.buttons}>
          <a
            className={styles.shopBtn}
            onClick={onClickLink}
          >
            Shop at NB.com
          </a>
          <a
            className={styles.athleteBtn}
            onClick={onClickMeet}
          >
            Meet Our Athletes
          </a>
        </div>
      </div>

      <button
        className={styles.muteButton}
        onClick={handleMuteToggle}
        aria-label={muted ? "Unmute video" : "Mute video"}
      >
        {muted ? (
          // Mute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>
        ) : (
          // Unmute icon (simple SVG)
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19 12c0-1.77-.77-3.29-2-4.29M19 12c0 1.77-.77 3.29-2 4.29M15 8.71V15.3"></path></svg>
        )}
      </button>
      <Popup visible={popupVisible} onHide={() => setPopupVisible(false)}>
        Redirects to New Balance website.
      </Popup>
    </div>
    
  );
};

export default MShopCTA; 
